import { render } from "./GroupDDetails.vue?vue&type=template&id=38d809b1&scoped=true"
import script from "./GroupDDetails.vue?vue&type=script&lang=js"
export * from "./GroupDDetails.vue?vue&type=script&lang=js"

import "./GroupDDetails.vue?vue&type=style&index=0&id=38d809b1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d809b1"]])

export default __exports__